export default "__VITE_ASSET__D9KP9eXH__"